import DropListNavbar from "./drop-list-navbar";
import DropListItemsTable from "./drop-list-items-table";
import DropListFooter from "./drop-list-footer";
import { useState } from "react";
import { Form, Formik } from "formik";

// How many BASE units one unit of the given uom_dropdown entry represents:
// a pack with base_quantity 10 and alt_quantity 1 is 10 base units. Falls back
// to 1 - "this UOM already IS the base unit" - whenever no usable pack size is
// present, so callers can divide by it unconditionally.
const computeUomRatio = (uom) => {
  const base = Number(uom?.base_quantity);
  const alt = Number(uom?.alt_quantity);
  return base > 0 && alt > 0 ? base / alt : 1;
};

// A base-unit quantity rendered in the row's UOM, at the same 2-decimal
// precision as the Recommended Qty column but without padding whole numbers,
// so the number input seeds with "2" rather than "2.00".
const toUomQtyString = (baseQty, ratio) =>
  String(Math.round((baseQty / ratio) * 100) / 100);

const buildItemRows = (itemData = []) =>
  (itemData || []).map((item, index) => {
    const uomDropdown = item?.uom_dropdown || [];
    const savedUomId = item?.item_uom_id ?? item?.uom_id;
    const defaultUom =
      uomDropdown.find(
        (entry) =>
          savedUomId != null && String(entry?.item_id) === String(savedUomId)
      ) ||
      uomDropdown[0] ||
      null;
    const ratio = computeUomRatio(defaultUom);
    const alreadyDropped = !!item?.dropped;
    const qtyToDropBase = Number(item?.qty_to_drop) || 0;

    return {
      row_key: `${item?.item_id}-${item?.to_bin_id}-${item?.item_batch_number}-${index}`,
      gort_id: item?.gort_id,
      gort_invoice_number: item?.gort_invoice_number,
      item_id: item?.item_id,
      item_code: item?.item_code,
      from_bin_id: item?.from_bin_id ?? null,
      from_bin_location: item?.from_bin_location ?? item?.from_bin_location_no ?? "",
      to_bin_id: item?.to_bin_id,
      bin_location_no: item?.bin_location_no,
      bin_priority: item?.bin_priority,
      item_batch_number: item?.item_batch_number,
      item_exp_date: item?.item_exp_date,
      is_overflow: !!item?.is_overflow,
      qty_to_drop_base: qtyToDropBase,
      uom_dropdown: uomDropdown,
      uom_id: defaultUom?.item_id ?? null,
      uom_name: item?.uom_name ?? null,
      uom_ratio: ratio,
      // qty_to_drop comes back in base units, but this column is entered and
      // displayed in the row's UOM - same as Recommended Qty - so a saved row
      // has to be converted rather than seeded with the raw base quantity.
      actual_qty_dropped: alreadyDropped
        ? toUomQtyString(qtyToDropBase, ratio)
        : "",
      dropped: alreadyDropped,
      already_dropped: alreadyDropped,
    };
  });

const CreateViewEditDropList = ({
  isClone = false,
  vendorDetails = [],
  itemData = [],
  disabled = false,
  page = "",
  standAlone = false,
  payto,
  shipto,
  pageType,
  transfer = false,
  storeDetails = {},
  dropListId,
  warehouseId,
  initialDropperId = null,
  initialDropperName = "",
  status,
  created_date="",
  trays,
  canEditTrays = false,
}) => {
  const initialFormValues = {
    cmr_code: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_code ?? "",
          value: vendorDetails?.[0]?.cmr_id ?? "",
        }
      : "",
    cmr_name: vendorDetails?.[0]?.cmr_id
      ? {
          label: vendorDetails?.[0]?.cmr_name,
          value: vendorDetails?.[0]?.cmr_id,
        }
      : "",
    cmr_id: vendorDetails?.[0]?.cmr_id,
    cmr_phone_number: vendorDetails?.[0]?.cmr_phone_number ?? "",
    dl_order_date: created_date,
    dl_pay_to_address: payto || null,
    dl_ship_to_address: shipto || null,
    dropper_id: initialDropperId,
    dropper_name: initialDropperName,
    dl_remarks: "",
    items: buildItemRows(itemData),
  };
  const [initialValue] = useState(initialFormValues);

  return (
    <Formik enableReinitialize={true} initialValues={initialValue}>
      {() => (
        <Form className="h-full">
          <div
            style={{
              height: `calc(100% - 9.5rem)`,
            }}
            className="mx-5 flex flex-col h-full "
          >
            <DropListNavbar
              isClone={isClone}
              pageType={pageType}
              page={page}
              disabled={disabled}
              transfer={transfer}
              standAlone={standAlone}
              storeDetails={storeDetails}
              dropListId={dropListId}
              trays={trays}
              canEditTrays={canEditTrays}
            />

            <DropListItemsTable
              disabled={disabled}
              warehouseId={warehouseId}
            />
          </div>

          <DropListFooter
            disabled={disabled}
            dropListId={dropListId}
            warehouseId={warehouseId}
            page={page}
            status={status}
          />
        </Form>
      )}
    </Formik>
  );
};
export default CreateViewEditDropList;
